module.exports = __webpack_public_path__ + "img/analytics.fb658020.svg";